import type { CustomerCardStoreState } from '../types/CustomerCardTypes';

const getSpdSlice = (rootState: CustomerCardStoreState) => rootState.activitiesCustomerSpd;

/** Presence flags for a participant*/
export const getSpdPresence = (ccid?: string) => (rootState: CustomerCardStoreState) =>
    ccid ? getSpdSlice(rootState)?.consumers?.[ccid]?.presence : undefined;

/** True while the CHECK SPD call is in flight (deal-level — one call covers all participants). */
export const getSpdCheckLoading = (rootState: CustomerCardStoreState) => getSpdSlice(rootState)?.checkLoading ?? false;

/** The check error for a participant (set on CHECK failure). */
export const getSpdCheckError = (ccid?: string) => (rootState: CustomerCardStoreState) =>
    ccid ? getSpdSlice(rootState)?.consumers?.[ccid]?.status?.checkError : undefined;

/** Whether the requesting user has Desking permission. Drives the "Show Data" CTA. */
export const getHasDeskingPermission = (rootState: CustomerCardStoreState) => getSpdSlice(rootState)?.canDesk ?? false;

/** The last SAVE error (set on SAVE_CUSTOMER_SPD_FAILURE). Cleared on SAVE_REQUEST. */
export const getSpdSaveError = (rootState: CustomerCardStoreState) => getSpdSlice(rootState)?.saveError;

/** GET SPD API status for a participant ('inFlight' | 'success' | 'error' | null). Shared across call
 *  sites (CustomerSpd's Show Data, BankInformation's eye icon) via Redux so a second trigger before the
 *  first resolves doesn't fire a duplicate GET, and a failed attempt doesn't block a retry. */
export const getSpdStatus = (ccid: string) => (rootState: CustomerCardStoreState) =>
    getSpdSlice(rootState)?.consumers?.[ccid]?.status?.getSpdStatus ?? null;
